import React, { useState, useEffect, useRef } from "react";
import {
	Box,
	Stack,
	Avatar,
	Typography,
} from "@mui/material";
import Message from "./Messages/TextMessage";
import MessageAndButtons from "./Messages/MessageAndButtons";
import Gallery from "./Messages/Gallery";
import DataCollector from "./Messages/DataCollector";
import ContactDataCollector from "./Messages/ContactDataCollector";
import ImageMessage from "./Messages/ImageMessage";
import FileInlinePreview from "./Files/FileInlinePreview";
import { useWidgetMsg } from "../hooks/widget/useWidgetMsg";
import { INTELSWIFT_GRAY_LOGO } from "../constants";

export default function Receiver(props) {
	let ReplyContent = null;
	const { content, agents } = props;
	const { agentIDaasId, type } = content;
	const [animate, setAnimate] = useState(false);
	const scrollRef = useRef(null);
	const { msg } = useWidgetMsg();

	const getAssistant = (agentIDaasId) => {
		const suffix = msg("conversations.ai_agent", "AI Agent");
		const name = agentIDaasId.substring("ai_assistant_".length) + ` (${suffix})`;
		if (!content?.config?.isSummaryGenerated) {
			return (
				<Stack direction="row" spacing={1}>
					<Avatar className="agent-avatar">{INTELSWIFT_GRAY_LOGO}</Avatar>
					<Typography variant="body1">{name}</Typography>
				</Stack>
			);
		}
	};

	const getAgent = (agentIDaasId) => {
		const agent = agents.find((el) => el.agentIDaasId === agentIDaasId);
		if (agent) {
			const { name } = agent;
			return (
				<Stack direction="row" spacing={1}>
					<Typography variant="body1">{name}</Typography>
				</Stack>
			);
		}
		return "";
	};

	switch (type) {
		case "msg_and_buttons":
			ReplyContent = <MessageAndButtons {...props} />;
			break;
		case "msg":
		case "assistant":
			ReplyContent = <Message {...props} recordId={props.recordId} />;
			break;
		case "gallery":
			ReplyContent = <Gallery {...props} />;
			break;
		case "image":
			ReplyContent = <ImageMessage link={content.link} />;
			break;
		case "contact_data_collector":
			ReplyContent = (
				<ContactDataCollector
					{...props}
					content={content}
					collectorState={props.contactDataCollector}
					recordId={props.recordId}
				/>
			);
			break;
		case "ticket_data_collector":
			ReplyContent = (
				<DataCollector
					{...props}
					content={content}
					collectorState={props.dataCollector}
					recordId={props.recordId}
				/>
			);
			break;
		case "connect_data_collector":
			ReplyContent = <DataCollector {...props} />;
			break;
		default:
			console.warn(`Unrecognized type ${type} of receiver content.`);
	}

	useEffect(() => {
		if (content) {
			setAnimate(true);
			const timeout = setTimeout(() => setAnimate(false), 500);
			return () => clearTimeout(timeout);
		}
	}, [content]);

	return (
		<>
			{content && (
				<Stack className="receiver-ui" direction="column" spacing={1}>
					<Stack className="receiver-info">
						{agentIDaasId && agentIDaasId !== "assistant" && getAgent(agentIDaasId)}
						{agentIDaasId && agentIDaasId.includes("ai_assistant") && getAssistant(agentIDaasId)}
					</Stack>
				<Box
					className={`receiver-message-container ${animate ? "animate-fade-in-left" : ""} ${type === "data_collector" || type === "gallery" ? "full-width" : "fit-content-width"}`}
				>
					{ReplyContent}
					{content.files && content.files.length > 0 && (
						<FileInlinePreview files={content.files} />
					)}
					<Box ref={scrollRef} />
				</Box>
				</Stack>
			)}
		</>
	);
}
